import React from "react";
import { connect } from "react-redux";

const navBadge = (props) => {
  let navBadges = false;
  if (props.items.badge) {
    const badgeClass = ["label", "pcoded-badge", props.items.badge.type];

    navBadges = (
      <span className={badgeClass.join(" ")}>
        {props.items.badge.title === "deviceCount" ? props.deviceCount 
        :props.items.badge.title === "pendingCount" ? props.pendingCount 
        :props.items.badge.title === "alertCount" ? props.alertCount 
        :props.items.badge.title}
      </span>
    );
  }
  return navBadges;
};

const mapStateToProps = (state) => {
  return {
    deviceCount: state.main.deviceCount,
    alertCount: state.main.alertCount,
    pendingCount: state.main.pendingCount,
  };
};

export default connect(mapStateToProps, null)(navBadge);
